import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const LoginContainer = styled(Common.Container)`
	width: 40%;
	min-width: 16rem;
	max-width: 30rem;
	max-height: 25vh;
	min-height: 14rem;
	margin-top: 10vh;
	padding: 10vh 2rem;
	row-gap: 0.5rem;
	border-radius: 10px;
	box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
`;

export const Title = styled.div`
	margin-bottom: 1rem;
	align-self: center;
	color: ${Theme.primary};
	font-family: 'Prompt', sans-serif;
	font-size: 24px;
`;

export const RootContainer = styled(Common.RootContainer)``;

export const DentiraLogo = styled(Common.DentiraLogo)``;

export const FlexRow = styled(Common.FlexRow)``;

export const Button = styled(Common.Button)``;

export const Waves = styled(Common.Waves)``;

export const InputGroup = styled(Common.InputGroup)``;

export const TextField = styled(Common.TextField)``;

export const Password = styled(Common.Password)``;

export const InputAdornment = styled(MUI.InputAdornment)``;

export const IconButton = styled(MUI.IconButton)``;
